import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { EmployeeDashboard } from 'app/shared/employee-dashboard-interface';
import { DatePipe } from '@angular/common';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ActivatedRoute, Router } from '@angular/router';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDatepicker } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

const moment = _rollupMoment || _moment;

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-yearly-report',
  templateUrl: './yearly-report.component.html',
  styleUrls: ['./yearly-report.component.scss'],
  animations: fuseAnimations,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YearlyReportComponent),
      multi: true,
    },
  ]
})
export class YearlyReportComponent implements OnInit {

  name: string;
  totalViolations = 0;
  totalYearlyEscalations = 0;
  totalLeaves = 0;
  resolvedViolations = 0;
  resolvedYearlyViolations = 0;
  dashboardGraph = [];
  totalDays = [];
  currentUser = this.parseService.instance.User.current();
  profileId = this.parseService.instance.User.current().get('profile').id;
  dashBoardData: EmployeeDashboard[] = [];
  widget5: { currentRange: string; xAxis: boolean; yAxis: boolean; gradient: boolean; legend: boolean; showXAxisLabel: boolean; xAxisLabel: string; showYAxisLabel: boolean; yAxisLabel: string; scheme: { domain: string[]; }; onSelect: (ev: any) => void; };
  widgets: Object = { 'widget5': { 'mainChart': { 'values': [{ 'name': '', 'series': [{ 'name': '', 'value': '' }] }] } } }
  widgetsValue: Object = { 'widget5': { 'mainChart': { 'values': [{ 'name': '', 'series': [{ 'name': '', 'value': '' }] }] } } }
  yAxisTicks: any[];
  xAxisTicks: any[];
  yScaleMax = 12;
  view: any[] = [460, 400];
  userName = '';
  announcementView = false;
  currentDate = new Date();
  today = this.currentDate.getDate() >= 10 ? new Date() : new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 0);
  holidaysList: any;
  imgUrl = '';
  back = false;
  reportsList = [];
  empRole = '';
  barCustomColors = [];
  reportMonthName: any;
  eachmonthDates = [];
  reportingTo = '';
  dateOfJoining = '';
  yearOfExperience = '';
  yearlyProjectList = [];
  yearlyResult = [];
  previousYear = (new Date().getFullYear()) - 1;
  listOfMonthDates = [];
  monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  _max: Moment;
  @Input()
  get max(): number | Date {
    return this._max ? this._max.year() : undefined;
  }
  set max(max: number | Date) {
    if (max) {
      const momentDate =
        typeof max === 'number' ? moment([max, 0, 1]) : moment(max);
      this._max = momentDate.isValid() ? momentDate : undefined;
    }
  }

  _min: Moment;
  @Input()
  get min(): number | Date {
    return this._min ? this._min.year() : undefined;
  }
  set min(min: number | Date) {
    if (min) {
      const momentDate =
        typeof min === 'number' ? moment([min, 0, 1]) : moment(min);
      this._min = momentDate.isValid() ? momentDate : undefined;
    }
  }

  touchUi = false;
  date = new Date();
  selectedYear = new Date(this.date.getFullYear() - 1, this.date.getMonth(), this.date.getDate());

  @ViewChild(MatDatepicker, { static: false }) _picker: MatDatepicker<Moment>;
  _inputCtr1: FormControl = new FormControl();

  /** send the focus away from the input so it doesn't open again */
  _takeFocusAway = (datepicker: MatDatepicker<Moment>) => { };

  constructor(
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private route: ActivatedRoute,
    private hardCodedValues: HardCodedValues,
    private router: Router,
    private spinner: NgxSpinnerService,
    private storageConfiguration: StorageConfiguration
  ) {
    this.widget5 = {
      currentRange: 'values',
      xAxis: true,
      yAxis: true,
      gradient: false,
      legend: false,
      showXAxisLabel: true,
      xAxisLabel: 'Days',
      showYAxisLabel: true,
      yAxisLabel: 'Working Hours',

      scheme: {
        domain: ['#53BFFC']
      },
      onSelect: (ev) => {

      },
    };
  }

  async ngOnInit() {
    let id = '';
    this.route.params.subscribe(async params => {
      id = params['id'];
    });
    if (id) {
      this.back = true;
    }
    else {
      this.back = false;
    }
    this.spinner.show();
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    let proId = this.parseService.instance.User.current().get('profile').id;
    const queryInstance = this.parseService.instance.Object.extend('_User');
    const query = new this.parseService.instance.Query(queryInstance);
    this.profileId = id == undefined ? proId : id;
    query.include('profile');
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    let userId = await query.find();
    this.currentUser = userId[0];
    let profile = this.currentUser.get('profile');
    this.imgUrl = profile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : profile.get('profileImageInfo').url;
    this.announcementView = id == undefined;

    this.getHolidaysList();
    this.getProfileData();
    this.getYearlyViolations();
    this.getEachMonthDates();
    this.getYearlyProjectDetails();
    this.getYearlyDashboardDetails();

  }

  async getHolidaysList() {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', this.previousYear);
    this.holidaysList = await holidayQuery.find();
  }

  getYearlyViolations() {
    var startDate = new Date(this.previousYear, 0, 1);
    var endDate = new Date(this.previousYear, 11, 31);
    const queryInstance = this.parseService.instance.Object.extend('UserViolations');
    const query = new this.parseService.instance.Query(queryInstance);
    query.include('userProfileId');
    query.include('reportingTo');
    query.include('userProfileId.role');
    query.greaterThan('violatedDate', startDate);
    query.lessThan('violatedDate', endDate);
    query.descending('updatedAt');
    query.equalTo('userProfileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    query.find().then(results => {
      this.totalViolations = results.length;
      const dashboardValues = [];
      results.forEach(element => {
        const dashboard: EmployeeDashboard = new EmployeeDashboard();
        dashboard.userProfileId = element.get('userProfileId').id;
        dashboard.violations = element.get('violations');
        dashboard.totalViolations = dashboard.violations.length;
        dashboard.status = element.get('status');
        if (dashboard.status === 'escalated') {
          this.totalYearlyEscalations = this.totalYearlyEscalations + 1;
        } else if (dashboard.status === 'resolved') {
          this.resolvedYearlyViolations = this.resolvedYearlyViolations + 1;
        }
        dashboardValues.push(dashboard);
      });
    });
  }

  async getProfileData() {
    const queryInstance = this.parseService.instance.Object.extend('Profile');
    const query = new this.parseService.instance.Query(queryInstance);
    query.include('reportingTo');
    query.equalTo('objectId', this.profileId);
    let results = await query.find();
    let profile = results[0];

    this.reportingTo = profile.get('reportingTo').get('firstName') + ' ' + profile.get('reportingTo').get('lastName');
    this.dateOfJoining = profile.get('officialInfo').doj;

    let experienceInYear = (profile.get('officialInfo').experience != undefined) && (profile.get('officialInfo').experience.year != undefined)
      && (profile.get('officialInfo').experience.year != '') ? profile.get('officialInfo').experience.year : 0;

    let experienceInMonth = (profile.get('officialInfo').experience != undefined) && (profile.get('officialInfo').experience.month != undefined) &&
      (profile.get('officialInfo').experience.month != '') ? profile.get('officialInfo').experience.month : 0;

    let totalExperience = (experienceInYear + '.' + experienceInMonth);
    this.yearOfExperience = totalExperience;
    this.userName = profile.get('firstName') + ' ' + profile.get('lastName');
    this.spinner.hide();
  }

  getYearlyProjectDetails() {
    this.yearlyProjectList = [];
    let monthList = [];
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
      [{ condition: 'include', value: 'project' }, { condition: 'limit', value: 10000 },
      { condition: 'include', value: 'project.client' }, { condition: 'include', value: 'user' },
      { condition: 'equalTo', field: 'user', value: { __type: 'Pointer', className: '_User', objectId: this.currentUser.id } }]).then(async results => {
        var startDate = new Date(this.previousYear, 0, 1);
        var endDate = new Date(this.previousYear, 11, 31);
        let timesheetResult = await this.getCurrentMonthWorkHours(startDate, endDate);
        for (const res of this.listOfMonthDates) {
          monthList = [];
          let projectHoursList = [];
          let allProjectHours = [];
          let currentMonthResults = timesheetResult.filter(x => x.get('createdAt').getTime() > res.startDate && x.get('createdAt').getTime() < res.endDate);
          for (const data of currentMonthResults) {
            let totalAttendance = data.get('totalAttendance');
            let projectDetails = totalAttendance.project;
            projectDetails.forEach(elementProject => {
              allProjectHours.push(elementProject);
            });
          }
          projectHoursList = allProjectHours.reduce(function (acc, val) {
            let o = acc.filter(function (obj) {
              return obj.id == val.id;
            }).pop() || { id: val.id, name: val.name, actualHours: 0 };
            o.actualHours += val.actualHours;
            if (acc.findIndex(x => x == o) == -1) {
              acc.push(o);
            }
            return acc;
          }, []);

          let hoursByProject = projectHoursList;
          let hoursSpent = 0;
          for (const element of results) {
            const projectDetails = JSON.parse(JSON.stringify(element));
            let matchedProject = hoursByProject.find(project => project.id == projectDetails.project.objectId);
            if (matchedProject != undefined) {
              hoursSpent = Number(this.secondsToHms(Math.ceil(matchedProject.actualHours / 1000)));
            } else {
              hoursSpent = 0;
            }
            let project = {
              projectName: projectDetails.project.projectInfo.projectName,
              projectType: projectDetails.project.projectInfo.projectType,
              currentStatus: projectDetails.project.projectInfo.currentStatus,
              hours: hoursSpent,
              role: projectDetails.role,
              resourcesType: projectDetails.resourcesType,
              id: projectDetails.project.objectId
            };
            let isPushed = monthList.find(x => x.id == projectDetails.project.objectId);
            if (hoursSpent > 0 && isPushed == undefined) {
              monthList.push(project);
            }
          }
          let currentDate = new Date(res.startDate);
          currentDate.setDate(currentDate.getDate() + 1);
          this.yearlyProjectList.push({
            month: this.monthNames[(currentDate).getMonth()],
            data: monthList.filter(this.onlyUnique)
          })
        }
      });
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  getEachMonthDates() {
    this.eachmonthDates = [];
    this.listOfMonthDates = [];
    for (let i = 0; i < 12; i++) {
      let date = new Date(this.previousYear, i, 1);
      const startend = this.startenddates(date);
      this.eachmonthDates.push(date);
      this.listOfMonthDates.push({
        startDate: startend[0].getTime(),
        endDate: startend[1].getTime()
      });
    }
  }

  async getYearlyDashboardDetails() {
    this.yearlyResult = [];
    for (const res of this.eachmonthDates) {
      let totalLeaves = 0;
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      this.reportMonthName = monthNames[res.getMonth()];
      this.dashboardGraph = [];
      let barCustomColors = [];

      let workHours;
      this.widgetsValue = {
        'widget5': {
          'mainChart': {
            'values': []
          }
        }
      };
      const AttendanceDB1 = this.parseService.instance.Object.extend('UserTimeSheet');
      const query = new this.parseService.instance.Query(AttendanceDB1);
      const startend = this.startenddates(res);
      query.equalTo('user', this.currentUser);
      query.descending('createdAt');
      query.greaterThan('createdAt', startend[0]);
      query.lessThan('createdAt', startend[1]);
      let results = await query.find();
      let workinDatesSheets = [];
      const workSheets = [];
      const createdAt = [];
      const values = [];
      let lastDayOfMonth = new Date(res.getFullYear(), res.getMonth() + 1, 0);
      const days = this.getLeaveWorkingDays(lastDayOfMonth);
      const workDates = days.workDays;
      const leaveDates = days.leaveDay;
      let totalWorkTime = [];
      let outTime;
      for (const innerElement of workDates) {
        workinDatesSheets = results.filter(x => new Date(x.get('createdAt')).getDate() === innerElement);
        for (const element of workinDatesSheets) {
          workSheets.push(element);
          let totalWorkHours = element.get('totalAttendance');
          let workHours = totalWorkHours.worktime;
          if (workHours > 0) {
            totalWorkTime.push(workHours);
          }
          else {
            totalWorkTime.push(28800);
          }
        }
      }
      let averageWorkHours = 0;
      if (totalWorkTime.length > 0) {
        averageWorkHours = totalWorkTime.map(item => item).reduce((prev, next) => prev + next);
      }
      else {
        averageWorkHours = 0;
      }
      let totalNoOfLeaves = workDates.length - workSheets.length;
      totalLeaves = totalNoOfLeaves < 0 ? 0 : totalNoOfLeaves;

      await this.getWorkingDays(lastDayOfMonth);

      this.totalDays.forEach(day => {
        let board = this.dashboardGraph.includes(day);
        if (!board) {
          this.dashboardGraph.push({
            'name': day,
            'series': [
            ]
          });
        }
      });
      results.forEach(element => {
        const totalWorkHours = element.get('totalAttendance');
        workHours = this.secondsToHms(totalWorkHours.worktime);
        const inTime = this.formateEpoch(element.get('inTime'));
        if (element.get('outTime') == 0) {
          outTime = '';
        } else {
          outTime = this.formateEpoch(element.get('outTime'));
        }

        const createDate = element.get('createdAt');
        createdAt.push(createDate.getDate());
        let indexOfBar = this.dashboardGraph.findIndex(x => x.name == createDate.getDate());
        this.dashboardGraph[indexOfBar].series = [
          {
            'name': inTime,
            'value': workHours.includes('-') == true ? "8" : workHours
          }
        ]
      });
      for (const workingDay of days.workDays) {
        let attendanceElement = this.dashboardGraph.findIndex(x => x.name == workingDay);
        if (this.dashboardGraph[attendanceElement].series.length == 0) {
          this.dashboardGraph[attendanceElement].series = [{ name: '', value: 8 }];
          barCustomColors.push({ "name": this.dashboardGraph[attendanceElement].series[0].name, "value": "#FF8181" });
        }
      }
      this.dashboardGraph.sort(function (a, b) { return a.name - b.name; });
      if (this.dashboardGraph.length > 0) {
        this.widgetsValue = {
          'widget5': {
            'mainChart': {
              'values': this.dashboardGraph
            }
          }
        };
      }
      this.yearlyResult.push({
        month: monthNames[res.getMonth()],
        value: this.widgetsValue,
        barCustomColors: barCustomColors,
        totalLeaves: totalLeaves,
        totalWorkHours: averageWorkHours == 0 ? '00:00' : this.secondsToHms((averageWorkHours / totalWorkTime.length))
      });
    }
    this.totalLeaves = this.yearlyResult.map(item => item.totalLeaves).reduce((prev, next) => prev + next);
  }

  async getCurrentMonthWorkHours(start, end) {
    const AttendanceDB1 = this.parseService.instance.Object.extend('UserTimeSheet');
    const query = new this.parseService.instance.Query(AttendanceDB1);
    query.equalTo('user', this.currentUser);
    query.descending('createdAt');
    query.greaterThan('createdAt', start);
    query.lessThan('createdAt', end);
    query.limit(1000);
    let results = await query.find();
    return results;
  }

  getLeaveWorkingDays(date) {
    const d = new Date(date);
    let holidayList = {};
    if (this.holidaysList != undefined && this.holidaysList.length > 0) {
      holidayList = this.holidaysList[0].get('dateList') != undefined ? this.holidaysList[0].get('dateList') : {};
    }
    let holidays = holidayList[d.getMonth()];

    const leaveDays = [];
    const workingDays = [];
    const getTot = this.daysInMonth(d.getMonth(), d.getFullYear(), d.getDate());
    const sat = [];
    const sun = [];
    const a = { a1: 20 };

    for (let i = 1; i <= getTot; i++) {

      const newDate = new Date(d.getFullYear(), d.getMonth(), i);
      if (newDate.getDay() == 0) {
        sun.push(i);
      }
      if (newDate.getDay() == 6) {
        sat.push(i);
      }
      if (newDate.getDay() != 6 && newDate.getDay() != 0) {
        workingDays.push(i);
      }

    }

    sun.forEach(s => {
      leaveDays.push(s);
    });
    sat.forEach((sa, index) => {
      if (index % 2 == 0) {
        leaveDays.push(sa);
      } else {
        workingDays.push(sa);
      }
    });
    if (holidays != undefined) {
      holidays.forEach(element => {
        let index = workingDays.findIndex(x => x == element);
        if (index != -1) {
          workingDays.splice(index, 1);
          leaveDays.push(element);
        }
      });
    }
    return { workDays: workingDays.sort(function (a, b) { return a - b; }), leaveDay: leaveDays.sort(function (a, b) { return a - b; }) };
  }

  daysInMonth(month, year, date) {
    return new Date(year, month, date).getDate();
  }

  getWorkingDays(event) {
    var date = new Date(event);
    var month = date.getMonth();
    var year = date.getFullYear();
    date = new Date(year, month, 1);
    var days = [];
    const allDays = [];
    while (date.getMonth() === month) {

      // Exclude weekends
      var tmpDate = new Date(date);
      var weekDay = tmpDate.getDay(); // week day
      var day = tmpDate.getDate(); // day
      allDays.push(day);
      if (weekDay % 6) { // exclude 0=Sunday and 6=Saturday
        days.push(day);
      }

      date.setDate(date.getDate() + 1);
    }
    this.totalDays = allDays;
    let dates = this.getLeaveWorkingDays(event);
  }

  onResize(event) {
    this.view = [event.target.innerWidth / 5.35, 300];
  }

  backlocation() {
    this.router.navigate(['employees-details']);
  }

  async holidayYearSelectedHandler(chosenDate: Moment, datepicker: MatDatepicker<Moment>) {
    let selectedDay = chosenDate.toDate();
    this.previousYear = selectedDay.getFullYear();

    this.getHolidaysList();
    this.getYearlyViolations();
    this.getEachMonthDates();
    this.getYearlyProjectDetails();
    this.getYearlyDashboardDetails();

    datepicker.close();
    if (!this.isYearEnabled(chosenDate.year())) {
      return;
    }
    chosenDate.set({ date: 1 });
    this._inputCtr1.setValue(chosenDate, { emitEvent: false });
    this.onChange(chosenDate.toDate());
    this.onTouched();
  }

  openDatepickerOnClick(datepicker: MatDatepicker<Moment>) {
    if (!datepicker.opened) {
      datepicker.open();
      this._max = moment(new Date());
    }
  }

  // Function to call when the date changes.
  onChange = (year: Date) => { };

  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => { };

  /** Whether the given year is enabled. */
  isYearEnabled(year: number) {
    // disable if the year is greater than maxDate lower than minDate
    if (
      year === undefined ||
      year === null ||
      (this._max && year > this._max.year()) ||
      (this._min && year < this._min.year())
    ) {
      return false;
    }

    return true;
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + '.' + mDisplay;
  }

  dayafter(d) {
    const day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  daybefore(d) {
    const day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  startenddates(day) {
    const startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    const enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  formateEpoch(date) {
    var datePipe = new DatePipe('en-US');
    const time = datePipe.transform(date, 'hh.mm');
    return time;
  }

}
